import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PlanerBtn from '../../atom/planer-btn/index.tsx'
import { trackMarketingEvent } from '../../../helpers/analytics.ts'
import { normalizeLanguage, withLang } from '../../../utils/langPath.ts'
import './index.css'

interface StepProps {
	number: string
	title: string
	description: string
}

const Step: React.FC<StepProps> = ({ number, title, description }) => (
	<div className='planer-step'>
		<div className='planer-step-number'>
			<span>{number}</span>
		</div>
		<h3 className='planer-step-title'>{title}</h3>
		<p className='planer-step-description'>{description}</p>
	</div>
)

const WeddingPlanerHowItWorks: React.FC = () => {
	const navigate = useNavigate()
	const { t, i18n } = useTranslation('planner')
	const lang = normalizeLanguage(i18n.language)
	const stepItems = t('landing.howItWorks.steps', { returnObjects: true }) as { title: string; description: string }[]

	return (
		<section className='planer-how-it-works-section'>
			<div className='planer-how-it-works-header'>
				<h2 className='planer-how-it-works-title'>
					{t('landing.howItWorks.title')}
				</h2>
				<p className='planer-how-it-works-subtitle'>
					{t('landing.howItWorks.subtitle')}
				</p>
			</div>

			<div className='planer-steps-container'>
				{stepItems.map((step, index) => (
					<Step
						key={index}
						number={String(index + 1).padStart(2, '0')}
						title={step.title}
						description={step.description}
					/>
				))}
			</div>

			<div className='planer-how-it-works-cta'>
				<PlanerBtn
					title={t('landing.howItWorks.cta')}
					onClick={() => {
					trackMarketingEvent('cta_click', 'planner_how_it_works_start')
					navigate(withLang(lang, '/weddingPlanner/login'))
				}}
					size='large'
				/>
			</div>
		</section>
	)
}

export default WeddingPlanerHowItWorks
